const themeManager = require('../view/themeUtil');

module.exports.numericThresholdValue = 0.001;

module.exports.storefrontTypes =
{
    POS: 'POS',
    UberEats: 'UberEats',
    JustEats: 'JustEats',
    Deliveroo: 'Deliveroo',
    KIOSK: 'KIOSK',
    MobileApp: 'MobileApp',
    WebApp: 'WebApp',
    FlipdishKIOSK: 'FlipdishKIOSK',
    FlipdishMobileApp: 'FlipdishMobileApp',
    FlipdishWebApp: 'FlipdishWebApp',
    ExternalApp: 'ExternalApp'
}

module.exports.VenueCodeProperty = "Property";
module.exports.VenueCodeMobileApp = "MobileApp";
module.exports.VenueCodeWebApp = "WebApp";
module.exports.VenueCodeDeliveroo = "Deliveroo";
module.exports.VenueCodeUberEats = "UberEats";
module.exports.VenueCodeJustEats = "JustEats";
module.exports.VenueCodeExternalApp = "ExternalApp";
module.exports.VenueCodeFlipdish = "Flipdish";

module.exports.PaymentMethodVenuePaid = "VenuePaid";
module.exports.PaymentMethodCash = "Cash";
module.exports.PaymentMethodCredit = "Credit";
module.exports.PaymentMethodCreditBook = "CreditBook";
module.exports.PaymentMethodOverPhone = "OverPhonePayment";
module.exports.PaymentMethodMix = "Mix";
module.exports.PaymentMethodNA = "NA";

module.exports.ReceiptLineTypeCharge = 'Charge';
module.exports.ReceiptLineTypeRefund = 'Refund';

module.exports.SaleTypeSale = 'Sale';
module.exports.SaleTypeHold = 'hold';
module.exports.SaleTypeStaffMeal = 'Staff.Meal';
module.exports.SaleTypeGuestsMeal = 'Guests.Meal';
module.exports.SaleTypeFreebiesMeal = 'Freebies.Meal';

module.exports.DispatchTypeDineIn = "DineIn";
module.exports.DispatchTypeTakeAway = "TakeAway";
module.exports.DispatchTypeCollection = "Collection";
module.exports.DispatchTypeDelivery = "Delivery";

module.exports.getDispatchTypeImages = function ()
{
    return [
        {value: this.DispatchTypeDineIn, imageUrl: themeManager.getPublicId("dinein.icon")},
        {value: this.DispatchTypeTakeAway, imageUrl: themeManager.getPublicId("takeaway.icon")},
        {value: this.DispatchTypeCollection, imageUrl: themeManager.getPublicId("collection.icon")},
        {value: this.DispatchTypeDelivery, imageUrl: themeManager.getPublicId("delivery.icon")},
    ];
}


module.exports.holdReasonCode = {
    staff: 'staff',
    paymentByPhone: 'paymentByPhone'
}

module.exports.WebPaymentProviders =
{
    stripe: "Stripe",
    stripeOverPhone: "StripeOverPhone"
}

module.exports.floorStencilType =
{
    Seating: 'Seating',
    Plants: 'Plants',
}

module.exports.KdsStatus =
{
    none: "none",
    completed: "completed"
};

module.exports.KdsStatusTypes =
{
    none: "none",
    status: "status",
    dueDateTime: "dueDateTime",
    activationDateTime: "activationDateTime",
    collapse: "collapse",
    print: "print"
};

module.exports.kitchenStationTypes =
{
    stationTypeMonitor: "Monitor",
    stationTypePrinter: "Printer"
};

module.exports.attendanceAccess =
{
    never: 'never',
    draft: 'draft',
    published: 'published'
}

module.exports.printingTemplateTypes =
{
    receipt: "receipt",
    kitchenStation: "kitchenStation",
    floatSession: "floatSession",
    voucher: "voucher",
    dailySummaryReport: "dailySummaryReport"
}

module.exports.floatManagementJournalEntryType =
{
    Withdraw: 'Withdraw',
    Deposit: 'Deposit',
}

module.exports.floatManagementJournalEntrySubType =
{
    TransferToSafe: 'TransferToSafe',
    Expense: 'Expense',
    ChangeGiven: 'ChangeGiven',

    OpeningBalance: 'OpeningBalance',
    TransferFromSafe: 'TransferFromSafe',
    ChangeReturned: 'ChangeReturned',
}

module.exports.channels =
{
    POS: 'POS',
    UrbanPiper: 'UrbanPiper',
    Deliverect: 'Deliverect',
    MobileApp: 'MobileApp',
    WebApp: 'WebApp',
    TableApp: 'TableApp',
    KIOSK: 'KIOSK',
}

module.exports.getChannelImages = function ()
{
    return [
        {value: this.channels.POS, imageUrl: "app/back.office/menu/property.pos.settings.icon.png"},
        {value: this.channels.KIOSK, imageUrl: "app/back.office/menu/kiosk.png"},
        {value: this.channels.WebApp, imageUrl: "app/back.office/venues/h1bhaekzilven1iomi6s"},
        {value: this.channels.TableApp, imageUrl: "app/back.office/menu/qr.ordering.app.jpg"},
        {value: this.channels.MobileApp, imageUrl: "app/back.office/venues/elqjd9yd08yaeess3qwl"},
        {value: this.channels.UrbanPiper, imageUrl: themeManager.getPublicId("Urban_Piper")},
        {value: this.channels.Deliverect, imageUrl: themeManager.getPublicId("Deliverect")},
    ]
};

module.exports.menuType =
{
    Primary: 'Primary',
    Reward: 'Reward',
    Kiosk: 'Kiosk'
}

module.exports.SnoozeTypes = 
{
    tag: "tag",
    property: "property",
    menuItem: "menu.item"
}

module.exports.SnoozeItemTypes = 
{
    categoryItem: "categoryItem",
    modifierItem: "modifierItem"
}

module.exports.ChargesTypes =
{
    VenueServiceCharges: "Venue.Service.Charges",
    VenueDeliveryCharges: "Venue.Delivery.Charges",
    Tip: "Tip",
};

module.exports.DiscountOfferTypes =
{
    Percentage: 'Percentage',
    Fixed: 'Fixed',
    Voucher: 'Voucher'
}

module.exports.triStateFlag =
{
    always: 'always',
    never: 'never',
    optional: 'optional',
}

module.exports.integrationTypes =
{
    cardPaymentManagement: "CardPaymentManagement",
    flipdish: "Flipdish",
}

module.exports.externalEntities =
{
    cardPaymentManagement: {
        worldPay: "WorldPay",
        handPoint: "HandPoint",
        paymentSense: "PaymentSense",
        stripeReader: "StripeReader",
        offline: "Offline"
    },
    flipdish: {
        flipdishStore: "FlipdishStore"
    }
}

module.exports.DiscountVoucherTypes =
{
    Percentage: 'percentage',
    Fixed: 'fixed'
}

module.exports.DiscountVoucherClaimType =
{
    oneTimeOnlyCustomer: 'oneTimeOnly.Customers',
    oneTimeOnlyNewCustomer: 'oneTimeOnly.NewCustomers',
    oneTimeOnlyGuest: 'oneTimeOnly.Guests',

    multipleTimesCustomer: 'multipleTimes.Customers',
    multipleTimesGuest: 'multipleTimes.Guests',
}


module.exports.activationThresholdInMinutes = 20;

module.exports.TagTypeSnooze = 'Snooze';